import { CARD_SURFACE } from '@/components/ui/section-card-variants'
import { cn } from '@/lib/utils'

/**
 * The FAQ list's boxes, shared by `FaqItem` and `FaqListSkeleton` so the
 * pending page is the loaded list's shape at every width. A `.ts` sibling so
 * both component files export only a component.
 *
 * A question row is 52px: `py-4` around one `text-h-s` line (20px), which is
 * also the 44px touch minimum with room to spare. A longer question wraps and
 * grows the row; the skeleton draws one-line questions.
 */
export const FAQ_LIST = cn(CARD_SURFACE, 'overflow-hidden')

export const FAQ_ROW = 'border-b border-border-subtle last:border-b-0'

export const FAQ_QUESTION = 'flex min-h-13 w-full items-center justify-between gap-4 px-5 py-4'
